import {Grid, Stack, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import greenLogo from "../assets/logos/DinoBooking_logo_oldalt_felirat_01.png"
import SocialButton from "./SocialButton";
import {Link} from "react-router";
import {useContext} from "react";
import ConfigContext from "../context/ConfigContext";


const DinoFooter = () => {
    const theme = useTheme()

    const primaryColor = {color: theme.palette.primary[700]}
    const {baseUrl} = useContext(ConfigContext)

    return <div className="dino-footer">
        <div className="dino-footer-content">
            <Grid container spacing={12}>
                <Grid item xs={12} md={6} lg={2}>
                    <Stack spacing={{xs: 2, md: 3, xl: 4}} style={{marginBottom: '20px'}}>
                        <Typography variant="caption" style={{color: '#A9BBC2'}}>Kontakt</Typography>
                        <Typography variant="buttonNormal" style={primaryColor}>3300, Eger Kossuth Lajos Utca 6.</Typography>
                        <Typography variant="button" style={primaryColor}>+36 30 380 53 40</Typography>
                        <Typography variant="button" style={primaryColor}>admin@dinobooking.hu</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <SocialButton onClick={() => window.open('https://www.facebook.com/dinobooking', '_blank')} inverted socialIcon={<FacebookOutlinedIcon/>}/>
                        <SocialButton onClick={() => window.open('https://instagram.com/dinobooking', '_blank')} inverted socialIcon={<InstagramIcon/>}/>
                        <SocialButton onClick={() => window.open('https://youtube.com/@DinoBooking', '_blank')} inverted socialIcon={<YouTubeIcon/>}/>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <Stack spacing={{xs: 2, md: 3, xl: 4}}>
                        <Typography variant="caption" style={{color: '#A9BBC2'}}>Szekciók</Typography>
                        <Link to="/" style={{textDecoration: 'none'}}>
                            <Typography variant="buttonNormal" style={primaryColor}>Kezdőlap</Typography>
                        </Link>
                        <Link to="/login" style={{textDecoration: 'none'}}>
                            <Typography variant="buttonNormal" style={primaryColor}>Bejelentkezés</Typography>
                        </Link>
                        <Link to="/register" style={{textDecoration: 'none'}}>
                            <Typography variant="buttonNormal" style={primaryColor}>Regisztráció</Typography>
                        </Link>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <Stack spacing={{xs: 2, md: 3, xl: 4}}>
                        <Typography variant="caption" style={{color: '#A9BBC2'}}>Dokumentumok</Typography>
                        <Typography variant="buttonNormal"><a style={primaryColor} target='_blank' rel="noreferrer" href="https://dinobooking.hu/adatvedelmi-tajekoztato">Adatvédelmi tájékoztató</a></Typography>
                        <Typography variant="buttonNormal"><a style={primaryColor} target='_blank' rel="noreferrer" href="https://dinobooking.hu/aszf">Általános Szerződési Feltételek</a></Typography>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <div className="dino-footer-container__own-logo">
                        <img src={greenLogo} alt="Dinobooking logo" width="150px"/>
                        <img onClick={() => window.location.href = 'https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf'} src={`${baseUrl}/public/simple-logo/`} alt="SimplePay logo" style={{cursor: 'pointer'}} width="150px"/>
                    </div>
                </Grid>
            </Grid>

        </div>
    </div>

}

export default DinoFooter